import React from "react";
import { Dropdown, Icon, Radio, Checkbox, Input } from "semantic-ui-react";
import CuDropdown from "../../../../common_component/component/CuDropdown";
import InputField from "../../../../common_component/component/InputField";
import { MdArrowDropDown } from "react-icons/md";
export const options2 = [
  { key: "English", text: "English", value: "English" },
  { key: "French", text: "French", value: "French" },
  { key: "Spanish", text: "Spanish", value: "Spanish" },
  { key: "German", text: "German", value: "German" },
  { key: "Chinese", text: "Chinese", value: "Chinese" },
];

export const options = [
  { key: 1, text: "Choice 1", value: 1 },
  { key: 2, text: "Choice 2", value: 2 },
  { key: 3, text: "Choice 3", value: 3 },
];

export const examples = [
  {
    name: "Text Field",
    example: "Text",
  },
  {
    name: "Text Box",
    example: "Multiple Lines Of Alphanumaric",
  },
  {
    name: "Number",
    example: "1234",
  },
  {
    name: "Date",
    example: <Input type="date" size="mini" />,
  },
  {
    name: "Dropdown",
    example: (
      <Dropdown placeholder="State" fluid search selection options={options} />
    ),
  },
  {
    name: "Multiple Selection",
    example: (
      <Dropdown
        options={options2}
        placeholder="Choose"
        search
        selection
        fluid
        multiple
        allowAdditions
      />
    ),
  },
  {
    name: "Radio Group",
    example: (
      <>
        <Radio label="Option 1" name="radioGroup" value="option1" />
        <br></br>
        <Radio label="Option 2" name="radioGroup" value="option2" />
      </>
    ),
  },
  {
    name: "Checkbox",
    example: <Checkbox label="Check this box" />,
  },
];

export const AllFields = [
  {
    name: "Text Field",
    type: "text",
    example: (
      <div className="h-full w-full flex items-center border pl-2">Text</div>
    ),
  },
  {
    name: "Text Area",
    type: "textarea", // Added type here
    example: (
      <div className="h-full w-full flex items-center border pl-2">
        Multiple Lines Of Alphanumeric
      </div>
    ),
  },
  {
    name: "Number",
    type: "number",
    example: (
      <div className="h-full w-full flex items-center border pl-2">1234</div>
    ),
  },
  {
    name: "Dropdown",
    type: "dropdown", // Added type here
    example: (
      <div className="w-full h-full flex justify-between items-center pl-2 pr-2 border">
        <span>Dropdown</span>
        <span>
          <MdArrowDropDown size={15} />
        </span>
      </div>
    ),
  },
  {
    name: "Radio Group",
    type: "radio", // Added type here
    example: (
      <div className="h-full w-full flex gap-3 border pl-2">
        <div className="flex items-center gap-2">
          <input type="radio" />
          <span>Option 1</span>
        </div>
        <div className="flex items-center gap-2">
          <input type="radio" />
          <span>Option 2</span>
        </div>
      </div>
    ),
  },
  {
    name: "Checkbox",
    type: "checkbox", // Added type here
    example: (
      <div className="h-full w-full flex items-center gap-2 border pl-2">
        <input type="checkbox" /> <span>Check</span>
      </div>
    ),
  },
  {
    name: "Descriptive Text",
    type: "descriptive", // Added type here
    example: (
      <div className="h-full w-full flex items-center border pl-2">
        Non-editable informational text
      </div>
    ),
  },
  {
    name: "Money",
    type: "money", // Added type here
    example: (
      <div className="h-full w-full flex items-center gap-2 border">
        <div className="flex-1 h-full border-r"></div>
        <div className="h-full border-l rounded">
          <select className="h-full px-2">
            <option>INR</option>
          </select>
        </div>
      </div>
    ),
  },
  {
    name: "Vitals",
    type: "vitals", // Added type here
    example: <div className="w-full h-full flex items-center px-2">Vitals</div>,
  },
];

export const cufrontModules = {
  appointment: [
    {
      id: 1,
      name: "Phone No",
      type: "Number",
    },
    {
      id: 2,
      name: "Patient Name",
      type: "Text Field",
    },
    {
      id: 3,
      name: "Age",
      type: "Number",
    },
    {
      id: 4,
      name: "DOB",
      type: "Date",
    },
    {
      id: 6,
      name: "Test Text",
      type: "Text",
    },
    {
      id: 7,
      name: "IPD Number",
      type: "Text Field",
    },
    {
      id: 8,
      name: "OPD Number",
      type: "Text Field",
    },
  ],
};
